import { render, staticRenderFns } from "./SiteMapMenuList.vue?vue&type=template&id=32663968&scoped=true&"
import script from "./SiteMapMenuList.vue?vue&type=script&lang=ts&"
export * from "./SiteMapMenuList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32663968",
  null
  
)

export default component.exports